import React from 'react';
import { KeyboardEventCodes } from 'src/constants/keyboardEventCodes';

export const onKeyDown = (
  e: React.KeyboardEvent<HTMLDivElement> | React.KeyboardEvent<SVGSVGElement>,
  /* eslint-disable-next-line */
  onClick: any
): void => {
  if (
    e.code === KeyboardEventCodes.SPACE ||
    e.code === KeyboardEventCodes.ENTER
  ) {
    e.preventDefault();
    onClick && onClick();
  }
};
